import { ClientLogger } from 'bernie-client';
import { ContextInput, getBexApiContext } from 'bernie-context';
import { SerializedData, timeoutPromise } from 'bernie-core';
import { KeyedObject } from 'bernie-core/dist/source';
import { ClientOptions, FetchPolicy } from 'bernie-graphql';
import { getErrorString, Logger } from 'bernie-logger';
import { ContextStore } from 'bernie-plugin-mobx';
import { action, runInAction } from 'mobx';
import { getTrackingInfoForLoggingFromHeaders } from '../common/logging-utils';
import { ActivityPageSeoContent, ActivityPageType } from '../common/__generated__/api/types';
import { LXStore, RequestWithTraceInfo } from './lx-store';
import { STORE_EVENTS } from './store-events';

export class ActivitySeoContentStore extends LXStore {
  private context?: ContextInput;
  public canonicalUrl: ActivityPageSeoContent.CanonicalUrl | null = null;
  public metaTags: ActivityPageSeoContent.MetaTags[] = [];
  public hreflangLinks: ActivityPageSeoContent.HreflangLinks[] = [];
  public title: string | null = null;
  public constructor(
    bexConfigs: ClientOptions,
    logger: Logger | ClientLogger,
    appConfig: KeyedObject = {},
    requestOrContext?: RequestWithTraceInfo | ContextInput
  ) {
    super(bexConfigs, logger, appConfig, requestOrContext);
    this.logger = logger;
  }

  public hydrate(data: SerializedData): void {
    super.hydrate(data);
  }

  public setContext(context: ContextStore): void {
    this.context = getBexApiContext(context);
  }

  @action
  public fetchActivitySeoContent(activityId: string, pageIdentity: string): Promise<any> {
    if (this.context) {
      const seoVariables: ActivityPageSeoContent.Variables = {
        pageType: ActivityPageType.ACTIVITY_INFO,
        context: this.context,
        activityId: activityId
      };

      return timeoutPromise(
        this.bexApiSource.operations.activityPageSeoContent(seoVariables, {
          pageId: pageIdentity,
          fetchPolicy: FetchPolicy.NO_CACHE,
          traceId: (this.headers && this.headers['trace-id']) || null,
          messageId: (this.headers && this.headers['message-id']) || null
        }),
        this.appConfig.timeout?.serverStoreFetch,
        `store=seoContent fetch=fetchActivitySeoContent timeout ${getTrackingInfoForLoggingFromHeaders(this.headers)}`
      )
        .then((response: KeyedObject) => {
          runInAction('update bex api activities search from response', () => {
            if (response?.data?.activitySeoContent) {
              this.canonicalUrl = response.data.activitySeoContent.canonicalUrl;
              this.metaTags = response.data.activitySeoContent.metaTags;
              this.hreflangLinks = response.data.activitySeoContent.hreflangLinks;
              this.title = response.data.activitySeoContent.title;
            }
          });
        })
        .catch((error: Error) => {
          this.logger.logEvent(STORE_EVENTS.SEO_CONTENT_FETCH_FAILED, getErrorString(error));
        });
    }

    return Promise.resolve();
  }
}
